<template>
  <div>
    <h3>استفد</h3>
    <hr />
    <p class="text-body">
      ادخل احتياجاتك لتتمكن المنظمات غير الحكومية من دعمك في تلبيتها والتشبيك
      معك .
    </p>
    <data-table ep="v2/all-assists?demanded=false" id="benfit" :fields="fields" class="my-1">
      <template #cell(assist.ngo)="{ value }">
        <a :href="`home/ngo/${value.id}`" target="_blank">{{
          value.name_ar
        }}</a>
      </template>
    </data-table>
  </div>
</template>

<script>
import DataTable from "@/components/data-table";
export default {
  components: {
    DataTable,
  },
  data() {
    return {
      fields: [
        { key: "assistCategory.name", label: "التصنيف" },
        { key: "assist.ngo", label: "اسم المنظمة" },
        { key: "governorate.name_ar", label: "المحافظة" },
        { key: "title", label: "الخدمة" },
        { key: "description", label: "الوصف" },
        { key: "count", label: "العدد" },
      ],
    };
  },
};
</script>
